<template>
  <SbLoadingPromiseWrapper :loadingPromise="dataLoadingPromise" size="xtsm">
    <div class="row cancel cancelTop">
      <a @click="closeDialog" id="btn-layout-wrapper-cancel" class="modal__close cancel"><span class="screen-reader-text">Close</span></a>
    </div>
    <h4 class="mb-30 text-xs-center">{{ $t('AssignNewPlans') }}</h4>
    <div class="col">
      <div class="row mb-5">
        <div class="col left">
          {{ $t('SelectCountry') }}
        </div>
      </div>
      <div class="row mb-30">
        <div class="col">
          <sb-dropdown v-model="selectedMerchantPlusCountry" :options="getMerchantPlusCountries"
            placeholder="Select Country">
            <sb-selected-option slot="selection" slot-scope="{ selected }">
              {{ selected }}
            </sb-selected-option>
            <sb-options>
              <sb-option slot-scope="{ option }" :value="option">
                {{ option.country_name }}
              </sb-option>
            </sb-options>
          </sb-dropdown>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col left">
          {{ $t('SelectNetworkPricing') }}
        </div>
      </div>
      <div class="row mb-5">
        <div class="col">
          <sb-dropdown v-model="selectedMerchantPlusPricingRegionByCountry" :options="getMerchantPlusPricingRegion" placeholder="Select Network Pricing">
            <sb-selected-option slot="selection" slot-scope="{ selected }">
              {{ selected }}
            </sb-selected-option>
            <sb-options>
              <sb-option slot-scope="{ option }" :value="option">
                {{ option.rootPricingRegionName }}
              </sb-option>
            </sb-options>
          </sb-dropdown>
        </div>
      </div>
      <div class="sub-panel" v-if="isMerchantPlusLocationsEnabled()">
        <div class="row mb-5">
          <div class="col left">
            {{ $t('MerchantPlusLocations') }}
          </div>
        </div>
        <div class="row mb-5">
          <div class="col">
            <p>{{ GetMerchantPlusFCLocationsText }}</p>
          </div>
        </div>
        <sb-panel variation="minimal">
          <div class="icon-wrapper icon-wrapper--center"><i class="sb-icon-alert-circle"></i></div>
          <p style="font-weight: 400;"> {{ $t('IPSTicketText') }}
            <a :href='ipsTicketUrl' target="_blank">Submit IPS Ticket</a>
          </p>
        </sb-panel>
      </div>
      <div class="mb-30"></div>
      <div class="row mb-5">
        <div class="col left">
          {{ $t('SelectDomesticPlan') }}
        </div>
      </div>
      <div class="row mb-30">
        <div class="col">
          <sb-dropdown-search v-model="selectedDomesticPricingPlan" :options="assignableDomesticPlans" :minSearchTermLength="0"
            @search="handleDomesticFilterPlans" :showSelectedOptions="true">
            <sb-selected-dropdown-search-option slot="selection" slot-scope="{ selection }"
              :value="mapPlanSelection(selection)" :title="mapPlanSelection(selection)"
              class="pricing-selected-dropdown"></sb-selected-dropdown-search-option>
            <sb-dropdown-option slot-scope="{ option }">{{ option.name }}</sb-dropdown-option>
          </sb-dropdown-search>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col left">
          {{ $t('SelecInternationalPlan') }}
        </div>
      </div>
      <div class="row mb-30">
        <div class="col">
          <sb-dropdown-search v-model="selectedInternationalPricingPlan" :options="assignableInternationalPlans"
            :minSearchTermLength="0" @search="handleInternationalFilterPlans" :showSelectedOptions="true">
            <sb-selected-dropdown-search-option slot="selection" slot-scope="{ selection }"
              :value="mapPlanSelection(selection)" :title="mapPlanSelection(selection)"
              class="pricing-selected-dropdown"></sb-selected-dropdown-search-option>
            <sb-dropdown-option slot-scope="{ option }">{{ option.name }}</sb-dropdown-option>
          </sb-dropdown-search>
        </div>
      </div>
      <div class="mb-15 sub-panel" style="background-color: white;">
        <sb-panel variation="minimal">
          <div class="icon-wrapper icon-wrapper--center sb-icon-alert-circle"></div>
          <p style="font-weight: 400;">{{ $t('AnalyticsTicketsText') }}
            <a :href='analyticsTicketUrl' target="_blank">Submit Analytics Ticket</a>
          </p>
        </sb-panel>
      </div>
      <div class="row center-button mb-15">
        <sb-button @click="handlePlanSave"> {{ $t('SavePricingPlan') }}</sb-button>
      </div>
      <div class="row center-button">
        <a @click="closeDialog">{{ $t('CancelPricingPlan') }}</a>
      </div>
    </div>
  </SbLoadingPromiseWrapper>
</template>

<script>
import toastr from 'toastr'
import ShipbobAppSettings from '@/appSettings/appSetting'
export default {
  name: 'AssignNewPlan',
  components: {},
  mixins: [],
  props: [],
  data: () => ({
    analyticsTicketUrl: ShipbobAppSettings.analyticsTicketsUrl,
    ipsTicketUrl: ShipbobAppSettings.ipsTicketUrl,
    domesticFilteredPlans: [],
    internationalFilteredPlans: [],
    plans: [],
    dataLoadingPromise: null
  }),
  mounted() {
    this.dataLoadingPromise = new Promise(async (resolve) => {
      await this.$shipBobStore.dispatch('admin/getMerchantPlusFCsAndCountries')
      resolve()
    })
   },
  destroyed() { },
  watch: {},
  computed: {
    assignableDomesticPlans() {
      this.plans = this.allAssignablePlans
      return this.domesticFilteredPlans.length === 0 ? this.plans : this.domesticFilteredPlans
    },
    assignableInternationalPlans() {
      this.plans = this.allAssignablePlans
      return this.internationalFilteredPlans.length === 0 ? this.plans : this.internationalFilteredPlans
    },
    allAssignablePlans: {
      get() {
        let selectedCountry = this.$shipBobStore.getters['admin/selectedMerchantPlusCountry']
        let filteredPlansViaCountry = []
        if(selectedCountry!=null)
        {
          let allPlans = this.$shipBobStore.getters['admin/allAssignablePlans']
          filteredPlansViaCountry = allPlans.filter(x => x.countryISO === selectedCountry.country_iso)/*filter all plans via selected country */
        }
        this.$shipBobStore.dispatch('admin/setSelectedDomesticPricingPlanV2')/*clear the old selected domestic and international pricing plan when populating dropdown */
        this.$shipBobStore.dispatch('admin/setSelectedInternationalPricingPlanV2')
        this.domesticFilteredPlans = []/*make the old filtered criteria and the list as empty when populating dropdown, this is to handler corner case when selected different country */
        this.internationalFilteredPlans = []
        return filteredPlansViaCountry
      }
    },
    selectedMerchantPlusLocations() {
      return this.$shipBobStore.getters['admin/selectedMerchantPlusFCsWithSelectedRegion']
    },
    selectedCountry() {
      return this.$shipBobStore.getters['admin/selectedCountry']
    },
    getMerchantPlusCountries() {
      return this.$shipBobStore.getters['admin/merchantPlusCountries']
    },
    getMerchantPlusPricingRegion() {
      let selectedCountry = (this.$shipBobStore.getters['admin/selectedMerchantPlusCountry'] == null ? null :this.$shipBobStore.getters['admin/selectedMerchantPlusCountry'].country_name)
      let merchantPlusPricingRegionsWithFCAndCountry = this.$shipBobStore.getters['admin/merchantPlusPricingRegionsWithFCAndCountries']
      const uniqueRegions2 = Object.values(merchantPlusPricingRegionsWithFCAndCountry.filter(x => x.fcCountryName === selectedCountry).reduce((o, a) => { o[a.rootPricingRegionId] = a; return o }, {}))
      this.$shipBobStore.dispatch('admin/setSelectedMerchantPlusPricingRegionByCountry')/*making already selected value as null */
      this.$shipBobStore.dispatch('admin/setSelectedMerchantPlusFCsWithSelectedRegion', [])
      return uniqueRegions2
    },
    GetMerchantPlusFCLocationsText() {
      let merchantPlusFCDetailsWithSelectedRegion = this.$shipBobStore.getters['admin/selectedMerchantPlusFCsWithSelectedRegion']
      let text = ''
      if (merchantPlusFCDetailsWithSelectedRegion != [] && merchantPlusFCDetailsWithSelectedRegion != null) {
        text = merchantPlusFCDetailsWithSelectedRegion.map(x => x.fulfillmentCenterName).join(', ')
      }
      return text
    },
    selectedMerchantPlusCountry: {
      get() {
        return (this.$shipBobStore.getters['admin/selectedMerchantPlusCountry']==null ? null : this.$shipBobStore.getters['admin/selectedMerchantPlusCountry'].country_name)
      },
      set(merchantPlusCountry) {
        if(merchantPlusCountry!=null)
        {
          this.$shipBobStore.dispatch('admin/setSelectedMerchantPlusCountry', merchantPlusCountry)
        }
      }
    },
    selectedMerchantPlusPricingRegionByCountry: {
      get() {
        return (this.$shipBobStore.getters['admin/selectedMerchantPlusPricingRegionByCountry'] == null ? null : this.$shipBobStore.getters['admin/selectedMerchantPlusPricingRegionByCountry'].rootPricingRegionName)
      },
      set(merchantPlusPricingRegion) {
        if (merchantPlusPricingRegion != null) {
          this.$shipBobStore.dispatch('admin/setSelectedMerchantPlusPricingRegionByCountry', merchantPlusPricingRegion)
          let merchantPlusFCsWithFCAndCountry = this.$shipBobStore.getters['admin/merchantPlusPricingRegionsWithFCAndCountries']
          let merchantPlusFCsWithSelectedPricingRegion = merchantPlusFCsWithFCAndCountry.filter(x => x.fcCountryISO === merchantPlusPricingRegion.fcCountryISO && x.pricingRegionId === merchantPlusPricingRegion.pricingRegionId)
          this.$shipBobStore.dispatch('admin/setSelectedMerchantPlusFCsWithSelectedRegion', merchantPlusFCsWithSelectedPricingRegion ?? [])
        }
      }
    },
    selectedDomesticPricingPlan:
    {
      get() {
        let domesticPricingPlan = this.$shipBobStore.getters['admin/selectedDomesticPricingPlan']
        if (domesticPricingPlan != null) {
          return domesticPricingPlan.name
        }
        else {
          return domesticPricingPlan
        }
      },
      set(domesticPricingPlan) {
        this.$shipBobStore.dispatch('admin/setSelectedDomesticPricingPlanV2', domesticPricingPlan)
      }
    },
    selectedInternationalPricingPlan:
    {
      get() {
        let internationalPricingPlan = this.$shipBobStore.getters['admin/selectedInternationalPricingPlan']
        if (internationalPricingPlan != null) {
          return internationalPricingPlan.name
        }
        else {
          return internationalPricingPlan
        }
      },
      set(internationalPricingPlan) {
        this.$shipBobStore.dispatch('admin/setSelectedInternationalPricingPlanV2', internationalPricingPlan)
      }
    }
  },
  methods: {
    isMerchantPlusLocationsEnabled() {
      let selectedRegionId = this.$shipBobStore.getters['admin/selectedMerchantPlusPricingRegionByCountry']
      return (selectedRegionId == null) ? false : true
    },
    async handlePlanSave() {
      if (this.saving) return
      this.saving = true
      let domesticPlan = this.$shipBobStore.getters['admin/selectedDomesticPricingPlan']
      let internationalPlan = this.$shipBobStore.getters['admin/selectedInternationalPricingPlan']
      let selectedRegionId = this.$shipBobStore.getters['admin/selectedMerchantPlusPricingRegionByCountry']
      let selectedPricingGroupId = 2
      if (domesticPlan != null && internationalPlan != null && selectedRegionId != null) {
        let payload = { DomesticPlanId: domesticPlan.planId, InternationalPlanId: internationalPlan.planId, PricingRegionId: selectedRegionId.pricingRegionId, PricingGroupId: selectedPricingGroupId }
        let res = await this.$shipBobStore.dispatch('admin/updateUserPlanData', payload)/*refresh data in drawer */
        if(res==='')
        {
          toastr['success']('New plan assigned successfully')
          this.closeDialog()/*closing the drawer on saving */
          this.$shipBobStore.dispatch("admin/getUserPricingPlans");/*refresh data in tables, not using async here */
        }
      }
      else {
        toastr['error'](this.$t('Please select Network Pricing, Domestic Pricing Plan and International Pricing Plan'))
      }
      this.saving = false
    },
    closeDialog() {
      this.$parent.handleClose()
      /*clearing all selected values on close*/
      this.$shipBobStore.dispatch('admin/setSelectedDomesticPricingPlanV2')
      this.$shipBobStore.dispatch('admin/setSelectedInternationalPricingPlanV2')
      this.$shipBobStore.dispatch('admin/setSelectedMerchantPlusPricingRegionByCountry')
      this.$shipBobStore.dispatch('admin/setSelectedMerchantPlusCountry')
    },
    mapPlanSelection(selection) {
      return selection ? selection : 'Select Pricing Plan'
    },
    handleDomesticFilterPlans({ searchTerm }) {
      this.domesticFilteredPlans = this.plans.filter(domesticPlan => {
        let unaccentedPlan = domesticPlan.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        let unaccentedSearchTerm = searchTerm.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        return unaccentedPlan.indexOf(unaccentedSearchTerm) !== -1
      })
    },
    handleInternationalFilterPlans({ searchTerm }) {
      this.internationalFilteredPlans = this.plans.filter(internationalPlan => {
        let unaccentedPlan = internationalPlan.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        let unaccentedSearchTerm = searchTerm.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        return unaccentedPlan.indexOf(unaccentedSearchTerm) !== -1
      })
    }
  },
  directives: {},
  filters: {

  },
  i18n: {
    messages: {
      'en-US': {
        NoneSelected: 'None selected',
        SelectCountry: 'Select Country',
        SelectNetworkPricing: 'Network Pricing',
        MerchantPlusLocations: 'Merchant+ Locations',
        SelectDomesticPlan: 'Domestic Pricing Plan',
        SelecInternationalPlan: 'International Pricing Plan',
        AssignNewPlans: 'Assign New Plan',
        SavePricingPlan: 'Save',
        CancelPricingPlan: 'Cancel',
        IPSTicketText: "Add pricing plan for individual location?",
        AnalyticsTicketsText: "Looking for a different Pricing Plan?"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import './admin-plan-panel.scss';
</style>
<style lang='scss'>
.sb-drawer__quit {
  display: none;
}
.cancelTop {
  flex-direction: row-reverse;
  font-family: proxima-nova;
}

.cancel {
  color: #9ea1a7;
}
  
.cancel {
  a {
    position: relative;
    bottom: 45px;
    right: 0px;
    width: 45px;
    height: 45px;
    &:before,
    &:after {
      content: ' ';
      display: block;
      position: absolute;
      top: 0px;
      right: 23px;
      width: 1px;
      height: 45px;
      background: black;
      transform: rotate(-45deg);
    }
    &:after {
      transform: rotate(45deg);
    }
    .screen-reader-text {
      display: none;
    }
  }
}
</style>